import { render, staticRenderFns } from "./AiSuggestionPanel.vue?vue&type=template&id=58456556&scoped=true"
import script from "./AiSuggestionPanel.vue?vue&type=script&lang=js"
export * from "./AiSuggestionPanel.vue?vue&type=script&lang=js"
import style0 from "./AiSuggestionPanel.vue?vue&type=style&index=0&id=58456556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58456556",
  null
  
)

export default component.exports